import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b0cd744&scoped=true&lang=pug&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=3b0cd744&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0cd744",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
